import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import { trackPromotionClick } from 'helpers'

export class CollectionFooter extends React.PureComponent<CollectionFooter.Props, CollectionFooter.State> {
  public static sectionId = 'colfoot';

  public render(): JSX.Element {
    const { section } = this.props
    const { settings, blocks } = this.props.section
    if (!settings) {
      return <React.Fragment/>
    }

    return (
      <section className={'dynamic-collection-footer'}>
        <div className={'max-w-7xl mx-auto pt-3-2 pb-0-7 md:py-6-4'}>
          <div className={'flex flex-wrap'}>
            <div className={'w-full md:w-1/3 relative px-1-2 mb-4-8 flex justify-center md:justify-start'}>
              <div className={'w-3/4'}>
                <Snippets.Heading tag={'h2'} size={'h1'} className={'mb-6-4 text-center md:text-left'}>
                  {settings.title}
                </Snippets.Heading>
                <ul className={'text-center md:text-left'}>
                  {settings.textlink.map((link, i) => {
                    return (
                      <li key={i}>
                        <Snippets.Button
                          colour={'link-small'}
                          onClick={() => trackPromotionClick(
                            [{
                              id: section.id,
                              name: settings.title,
                              creative: 'Collection footer'
                            }],
                            link.url
                          )}
                          title={link.text}
                        >
                          {link.text}
                        </Snippets.Button>
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
            {settings.imagelin.map((block, i) => {
              return (
                <div className={'w-full md:w-1/3 px-1-6 md:px-1-2 flex items-center mb-1-6'} key={i}>
                  <a 
                    onClick={() => trackPromotionClick(
                      [{
                        id: section.id,
                        name: settings.title,
                        creative: 'Collection footer',
                        position: `${i}`
                      }],
                      block.url
                    )}
                    title={block.title}
                    className={'w-full block bg-grey ratio-product relative border-r border-b border-grey-border'}
                  >
                    <div className={'absolute inset-0'}>
                      <Snippets.Image
                        alt={block.title || "Collection footer featured image"}
                        src={block.image}
                        className={'absolute inset-0'}
                        preventLazy
                      />
                      <div className={'absolute inset-0 z-10 flex items-center justify-center p-1-6 text-center'}>
                        <Snippets.Heading tag={'h2'} size={'h1'} className={'text-white'}>
                          {block.title}
                        </Snippets.Heading>
                      </div>
                    </div>
                  </a>
                </div>
              )
            })}
            
          </div>
        </div>
      </section>
    )
  }
}

export namespace CollectionFooter {
  export type Options = ShopifyNext.Section<{
    title: any;
    textlink: {
      url: string;
      text: string;
    }[];
    imagelin: {
      image: string;
      url: string;
      title: string;
    }[];
  }>;
  export interface Props extends GlobalProps {
    section: CollectionFooter.Options;
  }
  export interface State {}
}
